//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useRef } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid, useTheme, useMediaQuery } from '@material-ui/core';
// import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// import SimpleBar from 'simplebar-react';
import CloseIcon from '@material-ui/icons/Close';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { logPageView } from '../../system/firebase';

// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { PAGE_TITLE_RESOURCE_CENTER } from '../../common/constants';
import { getCopyrightText } from '../../common/textHelper';
import { AFITD_DOMAIN, PATH_RESOURCE_CENTER } from '../../system/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import bannerImg from '../../images/ResourceCenter/Article 3 Main Image.jpeg';
import bannerLogo from '../../images/ResourceCenter/article1Logo/afitd_primary_logo-01.svg';
import companyLogo from '../../images/ResourceCenter/article3Logo/company.png';
import stylingLogo from '../../images/ResourceCenter/article3Logo/styling.png';
import accessoryLogo from '../../images/ResourceCenter/article3Logo/accessory.png';
import { useHistory } from 'react-router-dom';

// import cardImg1 from '../../images/FAQ/Rectangle 202.png';
// import cardImg2 from '../../images/FAQ/Rectangle 2021.png';
// import cardImg3 from '../../images/FAQ/Rectangle 2022.png';
// import shareImg1 from '../../images/FAQ/Vector1.png';
// import shareImg2 from '../../images/FAQ/Vector2 (1).png';
// import shareImg3 from '../../images/FAQ/Vector3 (1).png';
// import shareImg4 from '../../images/FAQ/Ic_copy link.png';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../../common/elemental/AfitdPageHead';
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    topText: { fontWeight: 700, fontSize: '16px', lineHeight: '19px', color: '#111E14', textAlign: 'center' },
    heading: {
        color: '#21898A',
        fontWeight: 700,
        fontSize: '42px',
        lineHeight: '52px',
        textAlign: 'center',
        maxWidth: '700px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px' },
    },
    bannerImg: { textAlign: 'center', marginTop: '45px', marginBottom: '40px' },
    paragraph: {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    questionTitle: {
        fontSize: '22px',
        fontWeight: 'bold',
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    secondaryHeader: {
        color: '#21898A',
        fontSize: '26px',
        fontWeight: '700',
        lineHeight: '30px',
        marginTop: '70px',
        maxWidth: '730px',
        // margin: 'auto',
        marginBottom: '24px',
        [theme.breakpoints.down('sm')]: { fontSize: 22, lineHeight: '25px' },
    },
    social: { maxWidth: '730px', margin: 'auto', marginTop: '50px', display: 'flex', alignItems: 'center', marginBottom: '30px' },
    iconContainer: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: 'rgba(252, 130, 31, 0.13)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    socialText: { fontSize: '16px', fontWeight: 700, lineHeight: '19px', paddingLeft: '16px' },
    hr: { backgroundColor: '#F0F2F6', margin: 'auto', marginTop: 50, maxWidth: '840px' },
    navigations: { display: 'flex', justifyContent: 'space-between', maxWidth: '1100px', margin: 'auto', marginTop: '20px' },
    navigationIconContainer: {
        display: 'flex',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '1px solid #D5D7DD',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': { cursor: 'pointer' },
    },
    navigationText: { padding: '0 16px', fontSize: '20', width: '500', fontWeight: 'bold' },
    navigationButtonContainer: { display: 'flex', alignItems: 'center' },
    card: { width: '352px', borderRadius: '8px', border: '1px solid #D5D7DD', '&:hover': { cursor: 'pointer' } },
    cardContainer: { marginTop: '60px', marginBottom: 60 },
    cardContent: { marginBottom: '27px', marginLeft: '24px', marginRight: '20px', borderBottom: '20px solid #fafafc' },
    cardHeading: { fontSize: '26px', fontWeight: 'bold', lineHeight: '34px' },
    cardParagraph: { fontSize: '15px', fontWeight: 400, lineHeight: '24px' },
    cardSocial: { display: 'flex', alignItems: 'center', marginTop: '20px' },
    cardSocialText: { marginLeft: '9px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    cardSection: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center' },
    dateTime: { marginBottom: 0, marginTop: '24px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    shareImageContainer: { textAlign: 'center', marginBottom: '16px', position: 'relative', '&:hover': { cursor: 'pointer' }, [theme.breakpoints.down('sm')]: { marginRight: 10 } },
    shareContainer: { display: 'flex', flexDirection: 'column', marginLeft: '-75px', [theme.breakpoints.down('sm')]: { flexDirection: 'row', marginLeft: 0, marginTop: 50 } },
    shareContainer2: { display: 'flex', flexDirection: 'column', position: 'absolute', top: 0, right: 25, [theme.breakpoints.only('md')]: { top: 360, right: 10 } },
    paragraphContainer: {
        // height: 500,
        [theme.breakpoints.only('md')]: { paddingRight: 30 },
        position: 'relative',
        // overflowY: 'scroll',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    img: { width: '100%' },
    imgLogo: { display: 'flex', maxWidth: 275, zIndex: 1, marginTop: '-47px' },
    tableContainer: { border: '1px solid black', width: '100%', borderCollapse: 'collapse' },
    tableRow: { border: '1px solid black', padding: '5px 10px 10px 10px' },
    tableRowName: { border: '1px solid black', padding: '5px 10px 10px 10px', color: '#21898A', width: 170, fontWeight: 'bold' },
    skillTitle: { color: '#21898A', textDecoration: 'underline', fontWeight: 'bold' },
    skillContainer: { display: 'flex', justifyContent: 'space-around' },
    leftLogo: { width: 90, height: 90 },
    logoHeaderContainer: {
        display: 'flex',
        marginLeft: '121px',
        marginTop: '10px',
        marginBottom: '10px',
        alignItems: 'flex-end',
        [theme.breakpoints.down('md')]: { maxWidth: 730, margin: '0 auto' },
        [theme.breakpoints.down('sm')]: { marginLeft: 0 },
    },
    closeIconContainer: { display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' },
    closeIcon: { color: '#A4A6A5' },
    backToTopContainer: { display: 'flex', justifyContent: 'flex-end', maxWidth: '905px' },
    backToTopText: {
        textDecoration: 'underline',
        color: '#1DA98E',
        fontStyle: 'italic',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: 18,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    flexSpaceBetween: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    copyRightText: {
        marginLeft: theme.spacing(20),
        fontSize: '18px',
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
            fontSize: '14px',
            maxWidth: '220px',
        },
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, handleCloseIcon } = params;

    const defns = {
        icon: { fontSize: '30px', color: '#FC821F', opacity: 1 },
        navIconLeft: { marginLeft: '10px' },
        navIconRight: { marginLeft: '3px' },
        cardContainer: { container: true, spacing: 5 },
        cardSection: { item: true, lg: 4, md: 6, sm: 12, xs: 12 },
        cardIcon: { color: 'rgba(17, 30, 20, 0.4)' },
        pageContent: { container: true },
        paragraphContainer: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        shareContainer: { item: true, lg: 0, md: 0, sm: 12, xs: 12 },
        closeIcon: { onClick: handleCloseIcon },
        resourceCenterText: { target: '_blank', href: '/resource-center' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ArticleThree = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const theme = useTheme();
    // const matchesMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();
    const myRef = useRef(null);
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const pageTitle = `Dress For Success: Is that still a thing? | ${PAGE_TITLE_RESOURCE_CENTER}`;
    const pageTitleSeo = 'Business Professional Interview Outfits';

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(pageTitle);
    }, [pageTitle]);

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleNextButton = () => {
        history.push('/resource-center/4');
    };
    const handlePreviousButton = () => {
        history.push('/resource-center/2');
    };
    const handleCloseIcon = () => {
        history.push('/resource-center');
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, handleCloseIcon });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <AfitdPageHead
                title={pageTitleSeo}
                description="If you're looking to dress for success at your next job interview. Our helpful guide provides tips on how to conceptualize the perfect outfit that fits the dress code of the company!"
                keywords="business professional interview outfit, Professional Interview Outfit, business professional interview"
                canonicalUrl={`https://${AFITD_DOMAIN}${PATH_RESOURCE_CENTER}/3`}
            />
            <div ref={myRef} />
            <p {...defns.topText}>6 min read</p>
            <div {...defns.closeIconContainer}>
                <CloseIcon {...defns.closeIcon} />
            </div>
            <h1 {...defns.heading}>
                Dress For Success: <br /> Is that still a thing?
            </h1>
            <div {...defns.navigations}>
                <div {...defns.navigationButtonContainer} onClick={handlePreviousButton}>
                    <div {...defns.navigationIconContainer}>
                        <ArrowBackIosIcon style={{ ...defns.navIconLeft }} />
                    </div>
                    <span {...defns.navigationText}>Previous</span>
                </div>
                <div {...defns.navigationButtonContainer} onClick={handleNextButton}>
                    <span {...defns.navigationText}>Next</span>
                    <div {...defns.navigationIconContainer}>
                        <ArrowForwardIosIcon style={{ ...defns.navIconRight }} />
                    </div>
                </div>
            </div>

            <div {...defns.bannerImg}>
                <img {...defns.img} src={bannerImg} alt="" />
                <img {...defns.imgLogo} src={bannerLogo} alt="" />
            </div>

            <Grid {...defns.pageContent}>
                {matchesSm ? (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    “Dress for Success,” might seem like a cliché from your grandparent’s day, and to an extent it is, but the phrase still holds some relevance
                                    especially pertaining to job seekers. By today's standards, “Dressing for Success,” doesn’t necessarily mean donning a suit and tie, or a skirt
                                    and heels. The concept of dressing for the job you want has evolved with the times. To help bring you up to speed, we’ve outlined a few tips to
                                    help you conceptualize the perfect outfit for your next interview or day at the office.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={companyLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Company Research</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    An easy Google search should help you learn more about your soon-to-be employer. By reviewing their website, their company history, and their
                                    products you should be able to get a vibe for their brand and their culture. This will help you to determine their most likely dress code and
                                    what’s acceptable in terms of style for your attire.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={stylingLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Styling for Business</h2>
                                </div>
                                <p {...defns.paragraph}>When it comes to styling your outfit for business, there are a few classic dress codes to incorporate from:</p> <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}> Business Professional: </span>
                                    This is the old-school train of thought when it comes to dressing for success, and is also known as, “Business Traditional.” There are plenty of
                                    companies that still subscribe to this type of dress code such as law firms, corporate offices, or in most places where VIP executives might be
                                    found on a daily basis. <br />
                                    <br /> In this type of environment, both ladies and gents will want to stick to the classic neutral tone suit, but it’s cool if your accessories
                                    (like a tie, socks, or scarf) boast a pattern (by pattern we mean a stripe, maybe paisley, but nothing too wild like a cartoon character) or
                                    provide a pop of color.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Business Casual: </span>
                                    This is the most popular type of dress code adopted by the majority of companies today. Lying in-between Professional and Casual, suddenly with
                                    Business Casual you find yourself with way more options and the gift of selfexpression. If all else fails, and you aren’t sure what your
                                    potential employer’s standards are regarding dress, go with Business Casual. <br /> <br />
                                    In a Business Casual environment, you’ll want to stick with business staples like a button-down shirt, and a nice pair of slacks, a skirt, or
                                    trousers, but you can ditch the suit jacket. Ties become a choice rather than a requirement. You can also incorporate items like khaki’s,
                                    sweaters, and you can even get a little wild with your color choices – bust out those pastel button downs for Spring! In some offices, they may
                                    even let you slide with a super nice pair of well fitted jeans (no sagging, no holes). Double check on the jeans though as not every company is
                                    that lax. Sometimes jeans must be reserved for Casual Fridays (check on that too).
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Smart Casual: </span>
                                    Think of this as an upgraded mode of casual. You can basically wear what you want for the most part, but imagine that your outfit will be judged
                                    by Tim Gunn or Tan France. Smart casual is relaxed, but shows that you still care about the impression of your appearance in a professional,
                                    albeit informal setting. <br /> <br />
                                    For Smart Casual, definitely go for the nice jeans (still no holes) and a fitted t-shirt (no graphics, just a plain neutral color tee), but
                                    level up with a sport coat or blazer, and a trendy pair of shoes. Casual dresses, cardigans, sweaters, trendy accessories, bold colors and
                                    patterns, fun ties (we love a bold bow-tie) are all in play here. <br /> <br /> While there is glorious freedom in smartly dressing casually,
                                    there are also still a few rules. You should still not wear anything you would normally never wear in an office setting: clothes with holes of
                                    any kind, mini skirts/dresses, saggy/overly baggy pants...basically anything you’d wear to a night club, don’t wear it to work.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Work From Home: </span>
                                    When working from home your outfit should still reflect the dress code of your company. If you would normally wear a full suit to a meeting that
                                    doesn’t change just because you’re in the comfort of your home. You might get away with just the top half of the suit, but do so at your own
                                    risk. It could potentially be embarrassing for you to jump out of your seat, to quiet the dogs, during a meeting with the boss for them to find
                                    out that your suit pants are actually your weeknight sweatpants. <br />
                                    <br /> Most work from home situations are going to be business casual, but you should check with your company to confirm their expectations.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={accessoryLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>#1 Accessory: Confidence</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    What matters even more than your outfit is your level of confidence. No matter the situation whether it be an interview, your first day on the
                                    job, or your 1,000th day on the job, you need to show up in a rock star state of mind because that is what you are. Humility is a virtue, but so
                                    is recognizing your value.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    When you style your business outfits, make it personal to you. Follow the guidelines, but allow room for comfort. You aren’t going to feel
                                    confident in heels if you never wear them and they hurt your feet (hint: if you want height without the blisters, let wedges be your new bff).
                                    You aren’t going to be comfortable in a tie if you never wear them and keep getting flustered because you can’t get it tied properly (hint:
                                    spring for a fancy clip-on).
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    You know when you find the perfect workout look and you grind 110% harder because you know you’re turning heads in the gym? This is the same
                                    feeling you should go for with your work outfits. Select an outfit that feels good and makes you audibly go, “DANG,” when you look in the mirror
                                    because, DANG, you look good, and you know you’re about to crush any task that comes your way. When we look
                                    <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}> good, </span>
                                    we feel good, and feeling good is the ultimate confidence boost.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    You now hold the basic keys to dressing for success, but remember with great power comes great responsibility. Now go forth and seize the day in
                                    a killer outfit like the superstar that you are!
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    If you’re looking for more job tips be sure to check out the other blog posts in our <a {...defns.resourceCenterText}>Resource Center.</a>
                                </p>
                            </div>
                        </Grid>
                        {/* <Grid {...defns.shareContainer}>
                            <Tooltip title="Share the article on LinkedIn" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg1} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Twitter" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg2} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Facebook" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg3} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Copy the article link" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg4} alt="" />
                                </div>
                            </Tooltip>
                        </Grid> */}
                    </>
                ) : (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    “Dress for Success,” might seem like a cliché from your grandparent’s day, and to an extent it is, but the phrase still holds some relevance
                                    especially pertaining to job seekers. By today's standards, “Dressing for Success,” doesn’t necessarily mean donning a suit and tie, or a skirt
                                    and heels. The concept of dressing for the job you want has evolved with the times. To help bring you up to speed, we’ve outlined a few tips to
                                    help you conceptualize the perfect outfit for your next interview or day at the office.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={companyLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Company Research</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    An easy Google search should help you learn more about your soon-to-be employer. By reviewing their website, their company history, and their
                                    products you should be able to get a vibe for their brand and their culture. This will help you to determine their most likely dress code and
                                    what’s acceptable in terms of style for your attire.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={stylingLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Styling for Business</h2>
                                </div>
                                <p {...defns.paragraph}>When it comes to styling your outfit for business, there are a few classic dress codes to incorporate from:</p> <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}> Business Professional: </span>
                                    This is the old-school train of thought when it comes to dressing for success, and is also known as, “Business Traditional.” There are plenty of
                                    companies that still subscribe to this type of dress code such as law firms, corporate offices, or in most places where VIP executives might be
                                    found on a daily basis. <br />
                                    <br /> In this type of environment, both ladies and gents will want to stick to the classic neutral tone suit, but it’s cool if your accessories
                                    (like a tie, socks, or scarf) boast a pattern (by pattern we mean a stripe, maybe paisley, but nothing too wild like a cartoon character) or
                                    provide a pop of color.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Business Casual: </span>
                                    This is the most popular type of dress code adopted by the majority of companies today. Lying in-between Professional and Casual, suddenly with
                                    Business Casual you find yourself with way more options and the gift of selfexpression. If all else fails, and you aren’t sure what your
                                    potential employer’s standards are regarding dress, go with Business Casual. <br /> <br />
                                    In a Business Casual environment, you’ll want to stick with business staples like a button-down shirt, and a nice pair of slacks, a skirt, or
                                    trousers, but you can ditch the suit jacket. Ties become a choice rather than a requirement. You can also incorporate items like khaki’s,
                                    sweaters, and you can even get a little wild with your color choices – bust out those pastel button downs for Spring! In some offices, they may
                                    even let you slide with a super nice pair of well fitted jeans (no sagging, no holes). Double check on the jeans though as not every company is
                                    that lax. Sometimes jeans must be reserved for Casual Fridays (check on that too).
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Smart Casual: </span>
                                    Think of this as an upgraded mode of casual. You can basically wear what you want for the most part, but imagine that your outfit will be judged
                                    by Tim Gunn or Tan France. Smart casual is relaxed, but shows that you still care about the impression of your appearance in a professional,
                                    albeit informal setting. <br /> <br />
                                    For Smart Casual, definitely go for the nice jeans (still no holes) and a fitted t-shirt (no graphics, just a plain neutral color tee), but
                                    level up with a sport coat or blazer, and a trendy pair of shoes. Casual dresses, cardigans, sweaters, trendy accessories, bold colors and
                                    patterns, fun ties (we love a bold bow-tie) are all in play here. <br /> <br /> While there is glorious freedom in smartly dressing casually,
                                    there are also still a few rules. You should still not wear anything you would normally never wear in an office setting: clothes with holes of
                                    any kind, mini skirts/dresses, saggy/overly baggy pants...basically anything you’d wear to a night club, don’t wear it to work.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    <span style={{ fontWeight: 'bold' }}>Work From Home: </span>
                                    When working from home your outfit should still reflect the dress code of your company. If you would normally wear a full suit to a meeting that
                                    doesn’t change just because you’re in the comfort of your home. You might get away with just the top half of the suit, but do so at your own
                                    risk. It could potentially be embarrassing for you to jump out of your seat, to quiet the dogs, during a meeting with the boss for them to find
                                    out that your suit pants are actually your weeknight sweatpants. <br />
                                    <br /> Most work from home situations are going to be business casual, but you should check with your company to confirm their expectations.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={accessoryLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>#1 Accessory: Confidence</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    What matters even more than your outfit is your level of confidence. No matter the situation whether it be an interview, your first day on the
                                    job, or your 1,000th day on the job, you need to show up in a rock star state of mind because that is what you are. Humility is a virtue, but so
                                    is recognizing your value.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    When you style your business outfits, make it personal to you. Follow the guidelines, but allow room for comfort. You aren’t going to feel
                                    confident in heels if you never wear them and they hurt your feet (hint: if you want height without the blisters, let wedges be your new bff).
                                    You aren’t going to be comfortable in a tie if you never wear them and keep getting flustered because you can’t get it tied properly (hint:
                                    spring for a fancy clip-on).
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    You know when you find the perfect workout look and you grind 110% harder because you know you’re turning heads in the gym? This is the same
                                    feeling you should go for with your work outfits. Select an outfit that feels good and makes you audibly go, “DANG,” when you look in the mirror
                                    because, DANG, you look good, and you know you’re about to crush any task that comes your way. When we look
                                    <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}> good, </span>
                                    we feel good, and feeling good is the ultimate confidence boost.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    You now hold the basic keys to dressing for success, but remember with great power comes great responsibility. Now go forth and seize the day in
                                    a killer outfit like the superstar that you are!
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    If you’re looking for more job tips be sure to check out the other blog posts in our <a {...defns.resourceCenterText}>Resource Center.</a>
                                </p>
                                {/* <div {...defns.shareContainer2}>
                                <Tooltip title="Share the article on LinkedIn" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg1} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Twitter" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg2} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Facebook" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg3} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Copy the article link" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg4} alt="" />
                                    </div>
                                </Tooltip>
                            </div> */}
                            </div>
                        </Grid>
                    </>
                )}
            </Grid>

            <hr {...defns.hr} />
            <div {...defns.backToTopContainer}>
                <div {...defns.flexSpaceBetween}>
                    <div {...defns.copyRightText}>{getCopyrightText()}</div>
                    <p
                        {...defns.backToTopText}
                        onClick={() => {
                            setTimeout(() => {
                                myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 100);
                        }}
                    >
                        Back to the top
                    </p>
                </div>
            </div>

            {/* <h2 {...defns.heading}>Related Content</h2>
            <Grid {...defns.cardContainer}>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg1} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Remote Workstations for the Discerning Artists</h3>
                            <p {...defns.cardParagraph}>
                                Netflix is poised to become the world’s most prolific producer of visual effects and original animated content. To meet that demand, we need to
                                attract the world’s best artistic talent.{' '}
                            </p>
                        </div>
                    </div>
                </Grid>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg2} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Working Remotely: A Complete Guide to Turn You Into a Pro</h3>
                            <p {...defns.cardParagraph}>
                                Working remotely is more difficult in practice than in theory. Turn to this guide with actionable advice from veteran remote workers on how to
                                handle challenges that are
                            </p>
                        </div>
                    </div>
                </Grid>
                {matchesMd ? (
                    <></>
                ) : (
                    <Grid {...defns.cardSection}>
                        <div {...defns.card}>
                            <div {...defns.imageContainer}>
                                <img {...defns.img} src={cardImg3} alt="" />
                            </div>
                            <div {...defns.cardContent}>
                                <p {...defns.dateTime}>2 min read</p>
                                <h3 {...defns.cardHeading}>Brent Potts Joins Airbnb as Vice President of Community Support</h3>
                                <p {...defns.cardParagraph}>
                                    Today we are excited to announce that Brent Potts has joined Airbnb as Vice President of Community Support. Lorem ipsum dolor sit amet.
                                </p>
                            </div>
                        </div>
                    </Grid>
                )}
            </Grid> */}
        </div>
    );
};

export default ArticleThree;
